import React, { useState, useEffect, useCallback } from 'react'
import toast from '@st-operations/uikit/lib/toast'
import { BarLoader, Select } from '@st-operations/uikit/src/v2/index.js'
import debounce from 'lodash.debounce'

import { getCustomAudiences } from '_services/audience.js'
import { logErrorAsync } from '_lib/utility'

const formatLabel = (label) => {
  return label //No formatting
}

const AudiencesSelect = ({ ...selectProps }) => {
  const [audiences, setAudiences] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const getData = useCallback(
    debounce(async (q) => {
      setIsLoading(true)
      try {
        const audiences = await getCustomAudiences({ fields: 'id,name', limit: 20, q })
        setAudiences(
          audiences.items.map((audience) => ({
            value: audience._id,
            label: formatLabel(audience.name),
          }))
        )
      } catch (error) {
        logErrorAsync(error)
        toast.error('Error trying to load audiences. Please try again later.')
      }
      setIsLoading(false)
    }, 500),
    [setAudiences]
  )

  useEffect(() => {
    getData()
  }, [])

  const handleSearch = (query) => {
    if (query) {
      getData(query)
    } else {
      return
    }
  }

  const handleOnChange = (...args) => {
    const [selected] = args
    if (selected.label) {
      window.localStorage.setItem(`@data-explorer/audience/${selected.value}/name`, selected.label)
    }

    selectProps.onChange(...args)
  }

  return (
    <>
      <Select
        {...selectProps}
        onChange={handleOnChange}
        onInputChange={handleSearch}
        options={audiences}
        useReactSelect
      />
      <If condition={isLoading}>
        <BarLoader />
      </If>
    </>
  )
}

export default AudiencesSelect
